export default __webpack_public_path__ + "static/media/av2.e582e4ba.png";